import React from 'react'
import {useHistory } from 'react-router-dom';
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { 
    FieldBtn,
    GuestListTableContainer,
} from './dues.style';
import {
    TableHead,
    TableBodyRow
} from './../../../../widget/styledComponents/table.style'

import { Badge, Checkbox,IconButton,MoreIcon,Pagination,Spinner} from 'evergreen-ui';
import AddDuesButton from './addDuesButton';
import { gql,useQuery } from '@apollo/client';
import Cookies from 'js-cookie';
import AddAssetsPlaceholder from '../../../../widget/add_assets_placeholder';
import DuesAnalyticsWidgetAll from './widgets/analytics_all';
import { formatAmount } from '../../../../widget/util';

export const FETCH_DUES = gql`
query Dues_getByFacility($facilityId: ID!) {
  dues_getByFacility(facilityId: $facilityId) {
    _id
    facility
    properties
    title
    description
    defaultAmount
    payerType
    appliesToAllProperties
    startDate
    endDate
    isStarted
    isStopped
    createdAt
    id
  }
}

`;


function DuesPageWidget() {
const history = useHistory()

const [checked, setChecked] = React.useState(false)
const facilityId = Cookies.get('facilityId');

const { loading, data }  = useQuery(FETCH_DUES,{
variables: {
    facilityId:facilityId,
    pagination: {
        "cursor": null,
        "limit": 1000
    },
 },
});
  return (
    <div className=''>
        <br/><br/>
        <div className='row'>
            <div className='col s12 m3'>
            <PageTitleText>
                Dues
            </PageTitleText>
            </div>
            
        </div>  
       
        <DuesAnalyticsWidgetAll/>
        <GuestListTableContainer>
            <PageTitleText className=''>
                Dues
            </PageTitleText>
            <br/>
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>
                        <td>
                            <Checkbox
                            label="#"
                            checked={checked}
                            onChange={e => setChecked(e.target.checked)}
                            />
                        </td>
                    </TableHead>
                    <TableHead>Title</TableHead>
                    <TableHead>Dues Amount</TableHead>
                    <TableHead>Date created</TableHead>
                    <TableHead>Assigned to</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>-</TableHead>

                </tr>
                </thead>

                <tbody>
                    {loading && <Spinner/> }
                    {data &&
                    
                    data.dues_getByFacility.map((data) => 
                        <TableBodyRow
                            className={data.isStopped ?"grey":"transparent"}
                            
                            // onClick={() => console.log(data)}
                            onClick={() => history.push(`/duesOne/${data._id}`)}
                        >
                            <td>
                                <Checkbox
                                    label=""
                                    checked={checked}
                                />
                            </td>
                            <td>{data.title}</td>
                            <td>N{
                                formatAmount(parseFloat(data.defaultAmount))
                            }</td>
                            <td>{data.createdAt}</td>
                            <td>{data.payerType.replace(/_/g, ' ') }</td>
                            <td>
                                {(data.isStarted && !data.isStopped )  && <Badge color="green">Started</Badge>}
                                {(data.isStopped ) && <Badge color="red">Stopped</Badge>}
                            </td>
                            <td>
                                <IconButton 
                                    onClick={() => history.push(`/duesOne/${data._id}`)}
                                icon={MoreIcon}  />
                            </td>
                        </TableBodyRow>
                        )
                    }
                   
                </tbody>
            </table>
            <center>
                <AddAssetsPlaceholder/>
            </center>
            <Pagination className='transparent z-depth-0' page={1} totalPages={1}></Pagination>
            <center>
                    <AddDuesButton/>
                    
            </center>
        </GuestListTableContainer>

       
        <FieldBtn onClick={() => history.push('/duesSpecific') } className="waves-effect waves-light btn-flat mt-50 mb-100">
                <i class="material-icons right">arrow_forward</i>
                Create dues for specific properties here
        </FieldBtn>
        
    </div>
  )
}

export default DuesPageWidget